// extracted by mini-css-extract-plugin
export default {"container":"document_form_radio_container__1BRj4","input":"document_form_radio_input__1vFeC","tooltip":"document_form_radio_tooltip__AZh+T"};